import axios from 'axios';
import { V1API } from '../../../_helpers/APIPath';
import { encode, decode } from '../../dataMagic';
import { populateStore, performNetworkCall, buildFormData } from '@/store/asyncHelper';

const mutations = {};
const store = {};

populateStore(store, mutations, false);

export default {
    namespaced: true,

    state : {
        opportunities: [],
        opportunity_detail: {},
        opportunityLoading: false,
        opportunityError: false,

        submitSuccess: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_OPPORTUNITIES (state, items) {
            state.opportunities = items;
        },

        SET_OPPORTUNITY_DETAIL (state, items) {
            state.opportunity_detail = items;
        },

        OPPORTUNITIES_LOADING (state, loading) {
            state.opportunityLoading = loading;
        },

        OPPORTUNITIES_ERROR (state, hasError) {
            state.opportunityError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        async fetchOpportunities ({ commit }) {
            commit('OPPORTUNITIES_LOADING', true);
            commit('OPPORTUNITIES_ERROR', false);

            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };

            try{
                let result = await axios.get(V1API.opportunities_list, config);
                let response = result.data;

                commit('SET_OPPORTUNITIES', response.data);

            } catch(error) {
                commit('OPPORTUNITIES_ERROR', true);
            } finally {
                commit('OPPORTUNITIES_LOADING', false);
            }
        },

        async fetchOpportunityDetail ({ commit }, payload) {
            commit('OPPORTUNITIES_LOADING', true);
            commit('OPPORTUNITIES_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_opportunity_details + payload, config);
                let response = result.data.data
                commit('SET_OPPORTUNITY_DETAIL', response);

            } catch(error) {
                commit('OPPORTUNITIES_ERROR', true);
            }
            finally {
                commit('OPPORTUNITIES_LOADING', false);
            }
        },

        async addOpportunity ({commit, dispatch}, payload) {
            commit('OPPORTUNITIES_LOADING', true);
            commit('OPPORTUNITIES_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.post(V1API.create_opportunity, payload.opportunity, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                return response

            }catch (e) {
                commit('OPPORTUNITIES_ERROR', true);
            }finally {
                commit('OPPORTUNITIES_LOADING', false);
            }
        },

        async updateOpportunity ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_opprtunity + payload.id, payload.opportunity, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                return response

            }catch (e) {
                commit('OPPORTUNITIES_ERROR', true);
            }finally {
                commit('OPPORTUNITIES_LOADING', false);
            }
        },

        async deleteOpportunity({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.opportunities_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })

            dispatch ('fetchOpportunities')
            return response
        },

        async updateStatusToggle({ commit, dispatch }, payload) {
            let config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('access_token'),
                }
            };
            console.log(payload.delete);
            let response = await axios.get(V1API.spoton_status_toggle + payload.spoton_id, config).then(result=>{
                let data = result.data;
                return data;
            });

            dispatch ('fetchSpotOnList');

            return response;
        }
    },

    getters: {}
};
